/* Fan Zone מונדיאל 2026 - לוגיקת צד לקוח */
(function () {
  'use strict';

  var API = 'https://fan-zone-api.vercel.app';
  var NO_SCORER = 'ללא שערים (0:0)';
  var OTHER_SCORER = 'כובש אחר';
  var root = document.querySelector('.fz-page');
  if (!root) return;

  var me = {
    cid: root.dataset.cid || null,
    email: root.dataset.email || null,
    name: root.dataset.name || '',
    sig: root.dataset.sig || null
  };
  var LOGIN_URL = root.dataset.login || '/account/login';
  var loggedIn = !!(me.cid && me.sig);

  var listEl = document.getElementById('fz-pred-list');
  var loadingEl = document.getElementById('fz-loading');

  // ---------- עמוד "הניחושים שלי" ----------
  var mineList = document.getElementById('fz-mine-list');
  if (mineList) {
    if (loggedIn) renderMinePage(mineList);
    return;
  }

  // ---------- עמוד בראקט נוקאאוט ----------
  var bracketEl = document.getElementById('fz-bracket');
  if (bracketEl) {
    renderBracket(bracketEl);
    return;
  }

  // ---------- countdown ----------
  var cdTimer = null;
  function startCountdown(iso) {
    var target = Date.parse(iso);
    var d = document.getElementById('fz-cd-d'),
        h = document.getElementById('fz-cd-h'),
        m = document.getElementById('fz-cd-m'),
        s = document.getElementById('fz-cd-s');
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var diff = Math.max(0, target - Date.now()) / 1000;
      d.textContent = pad(Math.floor(diff / 86400));
      h.textContent = pad(Math.floor(diff % 86400 / 3600));
      m.textContent = pad(Math.floor(diff % 3600 / 60));
      s.textContent = pad(Math.floor(diff % 60));
      if (diff <= 0 && cdTimer) clearInterval(cdTimer);
    }
    tick();
    cdTimer = setInterval(tick, 1000);
  }

  function ilTime(iso) {
    try {
      var dt = new Date(iso);
      var date = new Intl.DateTimeFormat('he-IL', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'Asia/Jerusalem' }).format(dt);
      var time = new Intl.DateTimeFormat('he-IL', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Jerusalem' }).format(dt);
      return date + ' · ' + time + ' שעון ישראל';
    } catch (e) { return ''; }
  }

  function flagUrl(code) {
    return code ? 'https://flagcdn.com/w160/' + code.toLowerCase() + '.png' : '';
  }

  // ---------- render ----------
  function renderNext(next) {
    if (!next) return;
    var sec = document.getElementById('fz-next');
    sec.hidden = false;
    document.getElementById('fz-next-home').textContent = next.home_he;
    document.getElementById('fz-next-away').textContent = next.away_he;
    var hf = document.getElementById('fz-next-home-flag');
    var af = document.getElementById('fz-next-away-flag');
    hf.src = flagUrl(next.home_flag); hf.alt = 'דגל ' + next.home_he;
    af.src = flagUrl(next.away_flag); af.alt = 'דגל ' + next.away_he;
    if (next.stage) document.getElementById('fz-next-stage').textContent = 'המשחק הקרוב · ' + next.stage;
    document.getElementById('fz-next-time').textContent = ilTime(next.kickoff);
    startCountdown(next.kickoff);
  }

  // ---------- לוח המשחקים המלא ----------
  function ilDateHeader(iso) {
    var fmt = function (d) { return new Intl.DateTimeFormat('he-IL', { day: 'numeric', month: 'numeric', timeZone: 'Asia/Jerusalem' }).format(d); };
    var target = fmt(new Date(iso));
    var now = new Date();
    if (target === fmt(now)) return 'היום';
    if (target === fmt(new Date(now.getTime() + 86400000))) return 'מחר';
    if (target === fmt(new Date(now.getTime() - 86400000))) return 'אתמול';
    return new Intl.DateTimeFormat('he-IL', { weekday: 'long', day: 'numeric', month: 'long', timeZone: 'Asia/Jerusalem' }).format(new Date(iso));
  }
  function ilHour(iso) {
    return new Intl.DateTimeFormat('he-IL', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Jerusalem' }).format(new Date(iso));
  }
  function scheduleRow(m) {
    var live = m.status === 'IN_PLAY' || m.status === 'PAUSED';
    var done = m.status === 'FINISHED';
    // בסגנון FotMob: לפני המשחק שעה, אחריו תוצאה, באמצע בין הדגלים.
    // הבית מימין, החוץ משמאל (RTL), לכן הסדר במשבצת: away - home כדי שהמספר יתיישר לקבוצה הנכונה.
    var hs = m.score_home == null ? 0 : m.score_home;
    var as_ = m.score_away == null ? 0 : m.score_away;
    var mid =
      live ? '<b class="fz-sch-score live">' + as_ + ' - ' + hs + '</b>' :
      done && m.score_home != null ? '<b class="fz-sch-score">' + m.score_away + ' - ' + m.score_home + '</b>' :
      done ? '<span class="fz-sch-time">סיום</span>' :
      '<span class="fz-sch-time">' + ilHour(m.kickoff) + '</span>';
    function flagImg(flag) {
      return flag ? '<img src="' + flagUrl(flag) + '" alt="" width="20" height="20" loading="lazy">' : '';
    }
    return '<div class="fz-sch-row' + (done ? ' done' : '') + '">' +
      '<span class="fz-sch-team">' + escapeHtml(m.home_he) + flagImg(m.home_flag) + '</span>' +
      '<span class="fz-sch-mid">' + mid + '</span>' +
      '<span class="fz-sch-team">' + flagImg(m.away_flag) + escapeHtml(m.away_he) + '</span>' +
    '</div>';
  }

  function renderStandings(standings) {
    var el = document.getElementById('fz-standings');
    if (!el || !standings || !standings.length) return;
    el.innerHTML = standings.map(function (g) {
      return '<div class="fz-std-group"><div class="fz-std-title">' + escapeHtml(g.group) + '</div>' +
        '<div class="fz-std-head"><span></span><span>מש</span><span>הפ</span><span>נק</span></div>' +
        g.rows.map(function (t, i) {
          return '<div class="fz-std-row' + (i < 2 ? ' q' : '') + '">' +
            '<span class="fz-std-team">' +
              (t.flag ? '<img src="' + flagUrl(t.flag) + '" alt="" width="18" height="18" loading="lazy">' : '') +
              escapeHtml(t.he) + '</span>' +
            '<span>' + t.played + '</span>' +
            '<span>' + (t.gd > 0 ? '+' : '') + t.gd + '</span>' +
            '<b>' + t.points + '</b>' +
          '</div>';
        }).join('') + '</div>';
    }).join('');
  }
  function loadSchedule() {
    var listEl2 = document.getElementById('fz-schedule-list');
    if (!listEl2) return Promise.resolve(null);
    return fetch(API + '/api/schedule')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var ms = d.matches || [];
        if (!ms.length) return null;
        renderStandings(d.standings);
        var now = Date.now();

        function renderGroup(list) {
          var html = '', lastDay = '';
          list.forEach(function (m) {
            var day = ilDateHeader(m.kickoff);
            if (day !== lastDay) { html += '<div class="fz-sch-day">' + day + '</div>'; lastDay = day; }
            html += scheduleRow(m);
          });
          return html;
        }

        // צ'יפים לסינון לפי יום
        var dayKeys = [];
        ms.forEach(function (m) {
          var k = ilDateHeader(m.kickoff);
          if (dayKeys.indexOf(k) === -1) dayKeys.push(k);
        });
        var tabsHtml = '<div class="fz-sch-tabs"><button class="fz-sch-tab on" data-day="">הכל</button>' +
          dayKeys.map(function (k) { return '<button class="fz-sch-tab" data-day="' + escapeHtml(k) + '">' + escapeHtml(k) + '</button>'; }).join('') +
          '</div>';

        function renderList(dayFilter) {
          if (dayFilter) {
            // יום ספציפי: כל משחקי היום, כולל מה שהסתיים
            var list = ms.filter(function (m) { return ilDateHeader(m.kickoff) === dayFilter; });
            return renderGroup(list) || '<div class="fz-empty">אין משחקים ביום הזה</div>';
          }
          var upcoming = ms.filter(function (m) { return m.status !== 'FINISHED'; });
          var past = ms.filter(function (m) { return m.status === 'FINISHED'; });
          return (past.length
              ? '<details class="fz-sch-past"><summary>משחקים שהסתיימו (' + past.length + ')</summary>' + renderGroup(past) + '</details>'
              : '') +
            renderGroup(upcoming.slice(0, 24)) +
            (upcoming.length > 24
              ? '<details class="fz-sch-past"><summary>כל שאר המשחקים עד הגמר (' + (upcoming.length - 24) + ')</summary>' + renderGroup(upcoming.slice(24)) + '</details>'
              : '');
        }

        listEl2.innerHTML = tabsHtml + '<div id="fz-sch-body">' + renderList('') + '</div>';
        listEl2.querySelectorAll('.fz-sch-tab').forEach(function (btn) {
          btn.addEventListener('click', function () {
            listEl2.querySelectorAll('.fz-sch-tab').forEach(function (b) { b.classList.remove('on'); });
            btn.classList.add('on');
            document.getElementById('fz-sch-body').innerHTML = renderList(btn.dataset.day);
          });
        });

        // המשחק הקרוב האמיתי מכל הלוח
        var next = ms.find(function (m) { return m.status !== 'FINISHED' && Date.parse(m.kickoff) > now; });
        if (next) {
          renderNext({
            home_he: next.home_he, away_he: next.away_he,
            home_flag: next.home_flag, away_flag: next.away_flag,
            kickoff: next.kickoff,
            stage: next.group ? next.stage + ' · ' + next.group : next.stage
          });
        }
        return next;
      })
      .catch(function () { return null; });
  }

  function clockIcon() {
    return '<svg class="fz-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
  }
  function checkIcon() {
    return '<svg class="fz-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  }

  function matchCard(m, mine) {
    var card = document.createElement('div');
    card.className = 'fz-pred-card';
    card.dataset.key = m.match_key;

    var locked = m.status !== 'open' || Date.parse(m.kickoff) <= Date.now();
    var ph = mine ? mine.pred_home : 1;
    var pa = mine ? mine.pred_away : 1;

    var options = '<option value="" disabled' + (mine ? '' : ' selected') + '>בחרו מבקיע...</option>' +
      m.squads.concat([OTHER_SCORER, NO_SCORER]).map(function (p) {
        var sel = mine && mine.pred_scorer === p ? ' selected' : '';
        return '<option' + sel + '>' + escapeHtml(p) + '</option>';
      }).join('');

    card.innerHTML =
      '<div class="fz-pred-head">' +
        '<span class="fz-when">' + clockIcon() + escapeHtml(ilTime(m.kickoff)) + '</span>' +
        (locked
          ? '<span class="fz-status fz-status-locked">נעול</span>'
          : '<span class="fz-status fz-status-open">פתוח לניחוש</span>') +
      '</div>' +
      (m.pred_count >= 3 ? '<div class="fz-social">🔥 ' + (m.pred_count * 5) + ' אוהדים כבר ניחשו את המשחק הזה</div>' : '') +
      '<div class="fz-pred-teams">' +
        teamCol(m.home_he, m.home_flag, ph, 'h', locked) +
        '<span class="fz-pred-colon" aria-hidden="true">:</span>' +
        teamCol(m.away_he, m.away_flag, pa, 'a', locked) +
      '</div>' +
      '<div class="fz-scorer">' +
        '<label for="fz-sc-' + m.match_key + '">מי יבקיע ראשון במשחק?</label>' +
        '<div class="fz-select-wrap">' +
          '<select id="fz-sc-' + m.match_key + '"' + (locked ? ' disabled' : '') + '>' + options + '</select>' +
          '<svg class="fz-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>' +
        '</div>' +
      '</div>' +
      (mine ? '<div class="fz-mine">' + checkIcon() + 'הניחוש שלך נקלט: ' + mine.pred_home + ':' + mine.pred_away + ' · ' + escapeHtml(mine.pred_scorer) + '</div>' : '') +
      '<div class="fz-error" hidden></div>' +
      (locked
        ? '<button class="fz-cta fz-cta-locked" disabled>הניחושים נעולים</button>'
        : '<button class="fz-cta fz-submit">' + (mine ? 'עדכון ניחוש' : 'שליחת ניחוש') + '</button>');

    // steppers
    card.querySelectorAll('.fz-stepper button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var valEl = btn.parentElement.querySelector('.fz-val');
        var v = parseInt(valEl.textContent, 10);
        v += btn.dataset.dir === 'up' ? 1 : -1;
        valEl.textContent = Math.min(15, Math.max(0, v));
        updateScorerOptions(card, m);
      });
    });
    updateScorerOptions(card, m);

    var submit = card.querySelector('.fz-submit');
    if (submit) submit.addEventListener('click', function () { sendPrediction(card, m, submit); });
    return card;
  }

  function teamCol(name, flag, val, side, locked) {
    var dis = locked ? ' disabled' : '';
    return '<div class="fz-pred-team">' +
      '<img class="fz-flag-sm" src="' + flagUrl(flag) + '" alt="דגל ' + escapeHtml(name) + '" width="56" height="56" loading="lazy">' +
      '<span class="fz-tname">' + escapeHtml(name) + '</span>' +
      '<div class="fz-stepper" data-side="' + side + '">' +
        '<button type="button" data-dir="down" aria-label="הפחתת שער"' + dis + '>−</button>' +
        '<span class="fz-val">' + val + '</span>' +
        '<button type="button" data-dir="up" aria-label="הוספת שער"' + dis + '>+</button>' +
      '</div>' +
    '</div>';
  }

  // נטרול מבקיעים מקבוצה שלפי הניחוש לא כבשה (תוצאה עם 0)
  function scorerTeamOf(value) {
    return value.indexOf('·') > -1 ? value.split('·').pop().trim() : null;
  }
  function updateScorerOptions(card, m) {
    var h = parseInt(card.querySelector('[data-side="h"] .fz-val').textContent, 10);
    var a = parseInt(card.querySelector('[data-side="a"] .fz-val').textContent, 10);
    var sel = card.querySelector('select');
    if (!sel) return;
    Array.prototype.forEach.call(sel.options, function (opt) {
      if (!opt.value) return;
      var team = scorerTeamOf(opt.value);
      opt.disabled = !!(team && ((h === 0 && team === m.home_he) || (a === 0 && team === m.away_he)));
    });
    var cur = sel.options[sel.selectedIndex];
    if (cur && cur.value && cur.disabled) sel.value = '';
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ---------- submit ----------
  function sendPrediction(card, m, btn) {
    var errEl = card.querySelector('.fz-error');
    errEl.hidden = true;

    var consentEl = document.getElementById('fz-consent');
    if (consentEl && !consentEl.checked) {
      errEl.textContent = 'להשתתפות בהגרלה יש לאשר קבלת דיוור';
      errEl.hidden = false;
      return;
    }

    // לקוח בלי שם בחשבון: חובה למלא שם פעם אחת
    var nameEl = document.getElementById('fz-name');
    var typedName = nameEl ? nameEl.value.trim() : '';
    if (nameEl && typedName.length < 2) {
      errEl.textContent = 'כדי להשתתף, מלאו את השם שלכם למעלה (מוצג בטבלת המובילים)';
      errEl.hidden = false;
      nameEl.focus();
      return;
    }

    var h = parseInt(card.querySelector('[data-side="h"] .fz-val').textContent, 10);
    var a = parseInt(card.querySelector('[data-side="a"] .fz-val').textContent, 10);
    var scorer = card.querySelector('select').value;

    if (!scorer) {
      errEl.textContent = 'יש לבחור מבקיע ראשון';
      errEl.hidden = false;
      return;
    }
    if ((h === 0 && a === 0) !== (scorer === NO_SCORER)) {
      errEl.textContent = h === 0 && a === 0
        ? 'בניחוש 0:0 יש לבחור "ללא שערים"'
        : 'בתוצאה עם שערים יש לבחור מבקיע';
      errEl.hidden = false;
      return;
    }
    var sTeam = scorerTeamOf(scorer);
    if (sTeam && ((h === 0 && sTeam === m.home_he) || (a === 0 && sTeam === m.away_he))) {
      errEl.textContent = 'שילוב לא אפשרי: לפי הניחוש שלך ' + sTeam + ' לא מבקיעה במשחק';
      errEl.hidden = false;
      return;
    }

    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'שולח...';

    fetch(API + '/api/predict', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        cid: me.cid, email: me.email, sig: me.sig,
        name: typedName || me.name,
        save_name: !!typedName,
        match_key: m.match_key, pred_home: h, pred_away: a, pred_scorer: scorer,
        consent: consentEl ? consentEl.checked : false
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.error || 'שגיאה');
        var mineEl = card.querySelector('.fz-mine');
        var html = checkIcon() + 'הניחוש שלך נקלט: ' + h + ':' + a + ' · ' + escapeHtml(scorer);
        if (mineEl) { mineEl.innerHTML = html; }
        else {
          mineEl = document.createElement('div');
          mineEl.className = 'fz-mine';
          mineEl.innerHTML = html;
          card.insertBefore(mineEl, errEl);
        }
        btn.textContent = 'עדכון ניחוש';
        btn.disabled = false;
        confetti(card);
        showCrossSell(card, m, h, a);
      })
      .catch(function (e) {
        errEl.textContent = e.message;
        errEl.hidden = false;
        btn.textContent = orig;
        btn.disabled = false;
      });
  }

  // ---------- רינדור עמוד הניחושים שלי ----------
  function renderMinePage(container) {
    fetch(API + '/api/me?full=1&cid=' + encodeURIComponent(me.cid) +
      '&email=' + encodeURIComponent(me.email) + '&sig=' + encodeURIComponent(me.sig))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.error) throw new Error(data.error);
        container.innerHTML = '';
        if (!data.items.length) {
          container.innerHTML = '<div class="fz-empty">עוד לא שלחתם ניחושים. <a href="/pages/fan-zone" style="color:var(--fz-blue-deep);font-weight:700">לפינת הניחושים →</a></div>';
          return;
        }
        data.items.forEach(function (it) {
          var card = document.createElement('div');
          card.className = 'fz-pred-card';
          var finished = it.status === 'finished';
          var locked = finished || Date.parse(it.kickoff) <= Date.now();
          var statusHtml;
          if (it.correct === true) statusHtml = '<div class="fz-mine">' + checkIcon() + 'פגעת בול! נכנסת להגרלה השבועית 🎉</div>';
          else if (it.correct === false) statusHtml = '<div class="fz-mine" style="color:var(--fz-red);background:rgba(194,54,47,.08);border-color:rgba(194,54,47,.18)">לא הפעם. המשחק הבא כבר מחכה</div>';
          else if (locked) statusHtml = '<div class="fz-mine" style="color:var(--fz-text-2);background:rgba(124,137,168,.1);border-color:rgba(124,137,168,.2)">ממתין לתוצאת המשחק</div>';
          else statusHtml = '<div class="fz-mine" style="color:var(--fz-text-2);background:rgba(124,137,168,.1);border-color:rgba(124,137,168,.2)">אפשר לעדכן עד שריקת הפתיחה <a href="/pages/fan-zone" style="color:var(--fz-blue-deep);font-weight:700">בפינת הניחושים</a></div>';

          card.innerHTML =
            '<div class="fz-pred-head">' +
              '<span class="fz-when">' + clockIcon() + escapeHtml(ilTime(it.kickoff)) + '</span>' +
              (finished
                ? '<span class="fz-status" style="background:rgba(124,137,168,.12);color:var(--fz-text-2);border:1px solid rgba(124,137,168,.2)">הסתיים</span>'
                : locked
                  ? '<span class="fz-status fz-status-locked">נעול</span>'
                  : '<span class="fz-status fz-status-open">פתוח לעדכון</span>') +
            '</div>' +
            '<div class="fz-pred-teams">' +
              '<div class="fz-pred-team">' +
                '<img class="fz-flag-sm" src="' + flagUrl(it.home_flag) + '" alt="דגל ' + escapeHtml(it.home_he) + '" width="56" height="56" loading="lazy">' +
                '<span class="fz-tname">' + escapeHtml(it.home_he) + '</span>' +
              '</div>' +
              '<div style="text-align:center;padding-top:14px">' +
                '<div class="fz-val" style="width:auto;font-size:30px">' + it.pred_home + ':' + it.pred_away + '</div>' +
                '<div style="font-size:11px;color:var(--fz-text-3);font-weight:600">הניחוש שלי</div>' +
                (finished && it.score_home != null
                  ? '<div style="margin-top:8px;font-size:16px;font-weight:800;color:var(--fz-navy)">' + it.score_home + ':' + it.score_away + '</div><div style="font-size:11px;color:var(--fz-text-3);font-weight:600">תוצאה בפועל</div>'
                  : '') +
              '</div>' +
              '<div class="fz-pred-team">' +
                '<img class="fz-flag-sm" src="' + flagUrl(it.away_flag) + '" alt="דגל ' + escapeHtml(it.away_he) + '" width="56" height="56" loading="lazy">' +
                '<span class="fz-tname">' + escapeHtml(it.away_he) + '</span>' +
              '</div>' +
            '</div>' +
            '<div style="text-align:center;font-size:13.5px;color:var(--fz-text-2);font-weight:600">מבקיע ראשון: ' + escapeHtml(it.pred_scorer) +
              (finished && it.first_scorer ? ' <span style="color:var(--fz-text-3)">| בפועל: ' + escapeHtml(it.first_scorer) + '</span>' : '') +
            '</div>' +
            statusHtml;
          container.appendChild(card);
        });
      })
      .catch(function (e) {
        container.innerHTML = '<div class="fz-empty">שגיאה בטעינה: ' + escapeHtml(e.message) + '</div>';
      });
  }

  // ---------- ספירה לפתיחת ניחוש (24ש לפני) ----------
  function startOpensCountdowns() {
    var els = document.querySelectorAll('.fz-opens[data-opens]');
    if (!els.length) return;
    function tick() {
      els.forEach(function (el) {
        var diff = (Date.parse(el.dataset.opens) - Date.now()) / 1000;
        if (diff <= 0) { el.innerHTML = '🔓 נפתח! רעננו את העמוד כדי לנחש'; return; }
        var d = Math.floor(diff / 86400), h = Math.floor(diff % 86400 / 3600), m = Math.floor(diff % 3600 / 60);
        el.textContent = '🔓 נפתח לניחוש בעוד ' + (d > 0 ? d + ' ימים ' : '') + h + ' שעות ' + m + ' דק׳';
      });
    }
    tick();
    setInterval(tick, 60000);
  }

  // ---------- טוסט התחברות לאורחים ----------
  var toastTimer = null;
  function showLoginToast() {
    var t = document.getElementById('fz-login-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'fz-login-toast';
      t.className = 'fz-toast';
      t.innerHTML =
        '<span>⚽ חייבים להתחבר כדי לנחש</span>' +
        '<a href="' + LOGIN_URL + '" class="fz-toast-btn">התחברות חינם</a>';
      document.body.appendChild(t);
    }
    requestAnimationFrame(function () { t.classList.add('on'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 4000);
  }

  // ---------- קונפטי קליל בשליחת ניחוש ----------
  function confetti(card) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var rect = card.getBoundingClientRect();
    var colors = ['#1d4ed8', '#e9c46a', '#30d158', '#ff453a', '#0a84ff'];
    for (var i = 0; i < 36; i++) {
      var p = document.createElement('div');
      var size = 6 + Math.random() * 6;
      p.style.cssText = 'position:fixed;z-index:9999;pointer-events:none;border-radius:2px;' +
        'width:' + size + 'px;height:' + (size * 0.6) + 'px;' +
        'background:' + colors[i % colors.length] + ';' +
        'left:' + (rect.left + rect.width / 2) + 'px;top:' + (rect.top + 60) + 'px;' +
        'transition:transform 1.1s cubic-bezier(.15,.6,.35,1),opacity 1.1s ease-out;';
      document.body.appendChild(p);
      (function (el) {
        requestAnimationFrame(function () {
          var dx = (Math.random() - 0.5) * 320;
          var dy = 120 + Math.random() * 260;
          el.style.transform = 'translate(' + dx + 'px,' + dy + 'px) rotate(' + (Math.random() * 540 - 270) + 'deg)';
          el.style.opacity = '0';
        });
        setTimeout(function () { el.remove(); }, 1300);
      })(p);
    }
  }

  // ---------- Cross-sell אחרי ניחוש ----------
  function showCrossSell(card, m, h, a) {
    var old = card.querySelector('.fz-xsell');
    if (old) old.remove();
    // הנבחרת שניחשת שתנצח (או שתי הנבחרות בתיקו)
    var teams = h > a ? [[m.home_he, m.home_flag]] : a > h ? [[m.away_he, m.away_flag]] : [[m.home_he, m.home_flag], [m.away_he, m.away_flag]];
    var utm = 'utm_source=fan-zone&utm_medium=site&utm_campaign=wc2026-predict';
    var links = teams.map(function (t) {
      return '<a class="fz-xsell-link" href="/search?q=' + encodeURIComponent(t[0]) + '&type=product&' + utm + '">' +
        '<img src="' + flagUrl(t[1]) + '" alt="" width="22" height="22">החולצה של ' + escapeHtml(t[0]) + '</a>';
    }).join('');
    var box = document.createElement('div');
    box.className = 'fz-xsell';
    var shareText = 'ניחשתי ' + h + ':' + a + ' ל' + m.home_he + ' נגד ' + m.away_he +
      ' ב-FAN ZONE של Jerseys.co.il! בואו תנחשו גם, כל שבוע מוגרלת חולצת מונדיאל: ';
    var shareUrl = 'https://www.jerseys.co.il/pages/fan-zone?utm_source=whatsapp&utm_medium=share&utm_campaign=prediction';
    box.innerHTML =
      '<div class="fz-xsell-title">🎁 מאמינים בניחוש? תחגגו אותו עם החולצה</div>' +
      links +
      '<div class="fz-xsell-coupon">קוד <b>FANZONE11</b> = ‏11% הנחה על כל קולקציית המונדיאל</div>' +
      '<button type="button" class="fz-share-btn">' +
        '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M17.5 14.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.8.37-.27.3-1.04 1.02-1.04 2.5 0 1.47 1.07 2.89 1.22 3.09.15.2 2.11 3.22 5.1 4.51.71.31 1.27.49 1.7.63.72.23 1.37.2 1.88.12.57-.09 1.76-.72 2.01-1.41.25-.7.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35z"/><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5.05-1.32A10 10 0 1 0 12 2zm0 18.2a8.2 8.2 0 0 1-4.18-1.15l-.3-.18-3 .79.8-2.92-.2-.3A8.2 8.2 0 1 1 12 20.2z"/></svg>' +
        'לשתף את הניחוש בוואטסאפ' +
      '</button>';
    box.querySelector('.fz-share-btn').addEventListener('click', function () {
      window.open('https://wa.me/?text=' + encodeURIComponent(shareText + shareUrl), '_blank', 'noopener');
    });
    card.appendChild(box);
  }

  // ---------- מדף חולצות המונדיאל (Swiper, כמו הסליידרים באתר) ----------
  function loadShelf() {
    var wrap = document.getElementById('fz-shelf-wrap');
    var shelf = document.getElementById('fz-shelf');
    if (!wrap || !shelf) return;

    function loadSwiperAssets(cb) {
      if (window.Swiper) return cb();
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = wrap.dataset.swiperCss;
      document.head.appendChild(css);
      var s = document.createElement('script');
      s.src = wrap.dataset.swiperJs;
      s.onload = cb;
      document.head.appendChild(s);
    }

    fetch('/collections/world-cup-2026/products.json?limit=12')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var products = (d.products || []).filter(function (p) { return p.images && p.images.length; }).slice(0, 12);
        if (!products.length) { wrap.closest('.fz-section').hidden = true; return; }
        var utm = 'utm_source=fan-zone&utm_medium=site&utm_campaign=shelf';
        shelf.querySelector('.swiper-wrapper').innerHTML = products.map(function (p) {
          var price = p.variants && p.variants[0] ? Math.round(parseFloat(p.variants[0].price)) : null;
          var img = p.images[0].src.replace(/(\.[a-z]+)(\?|$)/, '_360x$1$2');
          return '<a class="fz-shelf-card swiper-slide" href="/products/' + p.handle + '?' + utm + '">' +
            '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' +
            '<span class="fz-shelf-title">' + escapeHtml(p.title) + '</span>' +
            (price ? '<span class="fz-shelf-price">₪' + price + '</span>' : '') +
          '</a>';
        }).join('');
        loadSwiperAssets(function () {
          new Swiper(shelf, {
            /* Whole cards only, same call as the homepage rail in
               sections/new-arrivals.liquid - a half-cropped shirt is a worse
               swipe hint than the autoplay already sitting under it. */
            slidesPerView: 2,
            spaceBetween: 12,
            grabCursor: true,
            loop: true,
            speed: 550,
            autoplay: { delay: 3200, disableOnInteraction: false, pauseOnMouseEnter: true },
            navigation: {
              prevEl: wrap.querySelector('[data-fz-prev]'),
              nextEl: wrap.querySelector('[data-fz-next]')
            },
            breakpoints: {
              400: { slidesPerView: 2, spaceBetween: 12 },
              640: { slidesPerView: 3, spaceBetween: 14 },
              900: { slidesPerView: 4, spaceBetween: 16 },
              1200: { slidesPerView: 5, spaceBetween: 18 }
            }
          });
        });
      })
      .catch(function () { wrap.closest('.fz-section').hidden = true; });
  }
  loadShelf();

  // ---------- טבלת מובילים ----------
  function loadLeaderboard() {
    var sec = document.getElementById('fz-board-sec');
    if (!sec) return;
    fetch(API + '/api/leaderboard')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var board = d.board || [];
        var podium = document.getElementById('fz-podium');
        var list = document.getElementById('fz-board-list');
        if (!board.length) {
          podium.innerHTML = '';
          list.innerHTML = '<div class="fz-empty">הפודיום עדיין ריק. אחרי המשחקים הראשונים, מי שיפגע בתוצאה ובמבקיע יופיע כאן. זה יכול להיות אתם!</div>';
          return;
        }
        var medals = ['🥇', '🥈', '🥉'];
        var top3 = board.slice(0, 3);
        // סדר תצוגה: שני, ראשון, שלישי
        var order = top3.length === 3 ? [top3[1], top3[0], top3[2]] : top3;
        podium.innerHTML = order.map(function (u) {
          return '<div class="fz-pod' + (u.rank === 1 ? ' p1' : '') + '">' +
            '<div class="fz-pod-medal">' + medals[u.rank - 1] + '</div>' +
            '<div class="fz-pod-name">' + escapeHtml(u.name) + '</div>' +
            '<div class="fz-pod-score">' + u.correct + ' ניחושים מלאים</div>' +
          '</div>';
        }).join('');
        list.innerHTML = board.slice(3).map(function (u) {
          return '<div class="fz-board-row"><span class="fz-board-rank">' + u.rank + '</span>' +
            '<b>' + escapeHtml(u.name) + '</b><span>' + u.correct + ' נכונים מתוך ' + u.total + '</span></div>';
        }).join('');
      })
      .catch(function () {});
  }
  loadLeaderboard();

  // ---------- קיר זוכים ----------
  function loadWinners() {
    var sec = document.getElementById('fz-winners-sec');
    if (!sec) return;
    fetch(API + '/api/winners')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var winners = d.winners || [];
        if (!winners.length) return; // אין זוכים מאושרים עדיין, נשאר מוסתר
        sec.hidden = false;
        document.getElementById('fz-winners-list').innerHTML = winners.map(function (w) {
          return '<div class="fz-winner">' +
            '<div class="fz-wbadge">🏆</div>' +
            '<div><b>' + escapeHtml(w.name) + '</b><span>שבוע ' + w.week + ' · ניחש ' + escapeHtml(w.prediction) + '</span></div>' +
          '</div>';
        }).join('');
      })
      .catch(function () {});
  }
  loadWinners();

  // ---------- load ----------
  loadSchedule().then(function (next) {
    // fallback: אם לוח המשחקים לא נטען, המשחק הקרוב מגיע ממשחקי הניחושים
    if (!next) {
      fetch(API + '/api/matches').then(function (r) { return r.json(); }).then(function (d) {
        if (d.next) renderNext(d.next);
      }).catch(function () {});
    }
  });

  fetch(API + '/api/matches')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.error) throw new Error(data.error);

      var open = data.open || [];
      var upcoming = data.upcoming || [];
      if (!open.length && !upcoming.length) {
        loadingEl.className = 'fz-empty';
        loadingEl.textContent = 'אין כרגע משחקים פתוחים לניחוש. חוזרים בקרוב עם המשחקים הבאים!';
        return;
      }

      var minePromise = loggedIn
        ? fetch(API + '/api/me?cid=' + encodeURIComponent(me.cid) +
            '&email=' + encodeURIComponent(me.email) +
            '&sig=' + encodeURIComponent(me.sig) +
            '&match_keys=' + encodeURIComponent(open.map(function (m) { return m.match_key; }).join(',')))
            .then(function (r) { return r.ok ? r.json() : { predictions: {} }; })
            .catch(function () { return { predictions: {} }; })
        : Promise.resolve({ predictions: {} });

      minePromise.then(function (mineData) {
        loadingEl.remove();
        open.forEach(function (m) {
          var card = matchCard(m, mineData.predictions[m.match_key] || null);
          if (!loggedIn) {
            // אורח: כל אינטראקציה עם הכרטיס מקפיצה טוסט התחברות
            card.querySelectorAll('.fz-stepper button').forEach(function (el) {
              el.addEventListener('click', function (ev) {
                ev.stopImmediatePropagation();
                showLoginToast();
              }, true);
            });
            var sel = card.querySelector('select');
            if (sel) {
              ['mousedown', 'touchstart', 'keydown'].forEach(function (evt) {
                sel.addEventListener(evt, function (ev) {
                  ev.preventDefault();
                  ev.stopImmediatePropagation();
                  sel.blur();
                  showLoginToast();
                }, true);
              });
            }
            var sub = card.querySelector('.fz-submit');
            if (sub) {
              sub.textContent = 'התחברות כדי לנחש';
              sub.addEventListener('click', function (ev) {
                ev.stopImmediatePropagation();
                window.location.href = LOGIN_URL;
              }, true);
            }
          }
          listEl.appendChild(card);
        });

        // משחקים שייפתחו לניחוש 24 שעות לפני השריקה
        upcoming.forEach(function (m) {
          var card = document.createElement('div');
          card.className = 'fz-pred-card fz-upcoming';
          card.innerHTML =
            '<div class="fz-pred-head">' +
              '<span class="fz-when">' + clockIcon() + escapeHtml(ilTime(m.kickoff)) + '</span>' +
              '<span class="fz-status" style="background:rgba(124,137,168,.12);color:var(--fz-text-2);border:1px solid rgba(124,137,168,.25)">בקרוב</span>' +
            '</div>' +
            '<div class="fz-pred-teams">' +
              '<div class="fz-pred-team"><img class="fz-flag-sm" src="' + flagUrl(m.home_flag) + '" alt="" width="56" height="56" loading="lazy"><span class="fz-tname">' + escapeHtml(m.home_he) + '</span></div>' +
              '<span class="fz-pred-colon" aria-hidden="true">:</span>' +
              '<div class="fz-pred-team"><img class="fz-flag-sm" src="' + flagUrl(m.away_flag) + '" alt="" width="56" height="56" loading="lazy"><span class="fz-tname">' + escapeHtml(m.away_he) + '</span></div>' +
            '</div>' +
            '<div class="fz-opens" data-opens="' + m.opens_at + '">🔓 הניחוש ייפתח 24 שעות לפני המשחק</div>';
          listEl.appendChild(card);
        });
        startOpensCountdowns();
      });
    })
    .catch(function () {
      loadingEl.className = 'fz-empty';
      loadingEl.textContent = 'שגיאה בטעינת המשחקים. נסו לרענן את העמוד.';
    });

  // ---------- בראקט נוקאאוט ----------
  function wireGuest(card) {
    card.querySelectorAll('.fz-stepper button').forEach(function (el) {
      el.addEventListener('click', function (ev) { ev.stopImmediatePropagation(); showLoginToast(); }, true);
    });
    var sel = card.querySelector('select');
    if (sel) ['mousedown', 'touchstart', 'keydown'].forEach(function (evt) {
      sel.addEventListener(evt, function (ev) { ev.preventDefault(); ev.stopImmediatePropagation(); sel.blur(); showLoginToast(); }, true);
    });
    var sub = card.querySelector('.fz-submit');
    if (sub) { sub.textContent = 'התחברות כדי לנחש'; sub.addEventListener('click', function (ev) { ev.stopImmediatePropagation(); window.location.href = LOGIN_URL; }, true); }
  }

  function staticKoCard(m) {
    var upcoming = m.status === 'upcoming';
    var card = document.createElement('div');
    card.className = 'fz-pred-card' + (upcoming ? ' fz-upcoming' : '');
    card.innerHTML =
      '<div class="fz-pred-head">' +
        '<span class="fz-when">' + clockIcon() + escapeHtml(ilTime(m.kickoff)) + '</span>' +
        (upcoming
          ? '<span class="fz-status" style="background:rgba(124,137,168,.12);color:var(--fz-text-2);border:1px solid rgba(124,137,168,.25)">בקרוב</span>'
          : '<span class="fz-status fz-status-locked">נעול</span>') +
      '</div>' +
      '<div class="fz-pred-teams">' +
        '<div class="fz-pred-team"><img class="fz-flag-sm" src="' + flagUrl(m.home_flag) + '" alt="" width="56" height="56" loading="lazy"><span class="fz-tname">' + escapeHtml(m.home_he) + '</span></div>' +
        '<span class="fz-pred-colon" aria-hidden="true">:</span>' +
        '<div class="fz-pred-team"><img class="fz-flag-sm" src="' + flagUrl(m.away_flag) + '" alt="" width="56" height="56" loading="lazy"><span class="fz-tname">' + escapeHtml(m.away_he) + '</span></div>' +
      '</div>' +
      (upcoming
        ? '<div class="fz-opens" data-opens="' + m.opens_at + '">🔓 הניחוש ייפתח 24 שעות לפני המשחק</div>'
        : '<div class="fz-mine" style="color:var(--fz-text-2);background:rgba(124,137,168,.1);border-color:rgba(124,137,168,.2)">נעול · ממתין לתוצאת המשחק</div>');
    return card;
  }

  function renderBracket(container) {
    var ROUND_NAMES = { R32: 'שלב 32 האחרונות', R16: 'שמינית גמר', QF: 'רבע גמר', SF: 'חצי גמר', TPF: 'מקום שלישי', FINAL: 'הגמר' };
    var ROUND_SEQ = ['R32', 'R16', 'QF', 'SF', 'TPF', 'FINAL'];
    fetch(API + '/api/matches')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.error) throw new Error(data.error);
        var ko = data.knockout || [];
        var openKeys = ko.filter(function (m) { return m.status === 'open'; }).map(function (m) { return m.match_key; });
        var minePromise = (loggedIn && openKeys.length)
          ? fetch(API + '/api/me?cid=' + encodeURIComponent(me.cid) + '&email=' + encodeURIComponent(me.email) +
              '&sig=' + encodeURIComponent(me.sig) + '&match_keys=' + encodeURIComponent(openKeys.join(',')))
              .then(function (r) { return r.ok ? r.json() : { predictions: {} }; }).catch(function () { return { predictions: {} }; })
          : Promise.resolve({ predictions: {} });

        minePromise.then(function (mineData) {
          container.innerHTML = '';
          var byRound = {};
          ko.forEach(function (m) { (byRound[m.bracket_round] = byRound[m.bracket_round] || []).push(m); });
          ROUND_SEQ.forEach(function (rk) {
            var items = byRound[rk] || [];
            var sec = document.createElement('section');
            sec.className = 'fz-round';
            sec.innerHTML = '<h2 class="fz-round-title"><span>' + ROUND_NAMES[rk] + '</span>' +
              (items.length ? '<span class="fz-round-count">' + items.length + ' משחקים</span>' : '') + '</h2>';
            var grid = document.createElement('div');
            grid.className = 'fz-round-grid';
            if (!items.length) {
              var tbd = document.createElement('div');
              tbd.className = 'fz-round-tbd';
              tbd.textContent = 'ייקבע לפי תוצאות השלב הקודם';
              grid.appendChild(tbd);
            } else {
              items.forEach(function (m) {
                if (m.status === 'open') {
                  var card = matchCard(m, mineData.predictions[m.match_key] || null);
                  if (!loggedIn) wireGuest(card);
                  grid.appendChild(card);
                } else {
                  grid.appendChild(staticKoCard(m));
                }
              });
            }
            sec.appendChild(grid);
            container.appendChild(sec);
          });
          startOpensCountdowns();
        });
      })
      .catch(function () {
        container.innerHTML = '<div class="fz-empty">שגיאה בטעינת הבראקט. נסו לרענן את העמוד.</div>';
      });
  }
})();
